/**
 * @memo FrankXiao: 修改路徑前須考量h365-platform-api, h365-payment-api 後端是否有寫死前端路由的狀況
 */
export default [
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/views/payment'),
    children: [
      {
        path: 'createdOrder',
        name: 'payment-create-order',
        component: () => import('@/views/payment/createdOrder')
      },
      {
        path: 'success',
        name: 'payment-success',
        component: () => import('@/views/payment/success')
      },
      {
        path: 'failed',
        name: 'payment-failed',
        component: () => import('@/views/payment/failed')
      },
      {
        path: 'inProgress',
        name: 'payment-inprogress',
        component: () => import('@/views/payment/inProgress')
      },
      {
        path: 'reLoginTip',
        name: 'payment-relogin',
        component: () => import('@/views/payment/reLoginTip')
      },
      {
        path: 'waitingPage',
        name: 'payment-waiting',
        component: () => import('@/views/payment/waitingPage')
      }
    ]
  }
]